module.exports = __webpack_public_path__ + "images/mountains.png?v=c96afc580560dd84a112715db7eee06e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mountains.png
// module id = 623
// module chunks = 0